import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { SignIn } from './features/auth/pages/SignIn';
import { OrderCheckout } from './features/checkout/pages/OrderCheckout';
import { OrderCheckoutComplete } from './features/checkout/pages/OrderCheckoutComplete';
import { CommentsList } from './features/comment/pages/CommentsList';
import { CustomerDetails } from './features/customer/pages/CustomerDetails';
import { CustomerList } from './features/customer/pages/CustomerList';
import { LiveDetails } from './features/live/pages/LiveDetails';
import { LiveList } from './features/live/pages/LiveList';
import { OrderDetails } from './features/order/pages/OrderDetails';
import { OrderList } from './features/order/pages/OrderList';
import { PaymentList } from './features/payment/pages/PaymentList';
import { ProductList } from './features/product/pages/ProductList';
import { Settings } from './features/settings/pages/Settings';
import { StockPage } from './features/stock/pages/stock';
import { RefundList } from './features/refund/pages/RefundList';
import SumUpPage from './sumup';
import { TabletPage } from './tablet';
import { InvoicePage } from './invoice';
import { PersonalPage } from './personal';
import { LiveStatisticsPage } from './features/statistics/live';
import { NetProfitPage } from './features/statistics/profit';
import { ShippingPage } from './features/shipping/pages/ShippingPage';
import { MonitorPage } from './monitor';
import { ParcelListPage } from './features/parcel/pages/ParcelList';
import { PrivacyPage } from './privacy';
import { BroadcastPage } from './broadcast';

export const router = createBrowserRouter([
  {
    path: '/sign-in',
    element: <SignIn />,
  },
  {
    path: '/checkout/:orderId',
    element: <OrderCheckout />,
  },
  {
    path: '/checkout/complete',
    element: <OrderCheckoutComplete />,
  },
  {
    path: '/link/:orderId',
    element: <SumUpPage />,
  },
  {
    path: '/tablet/:liveId',
    element: <TabletPage />,
  },
  {
    path: '/stock',
    element: <StockPage />,
  },
  {
    path: '/monitor',
    element: <MonitorPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    // element: <AuthOutlet fallbackPath="/sign-in" />,
    children: [
      {
        element: <Layout />,
        children: [
          {
            path: '/',
            element: <LiveStatisticsPage />,
          },
          {
            path: '/profit',
            children: [
              {
                index: true,
                element: <NetProfitPage />,
              },
            ],
          },
          {
            path: '/live',
            children: [
              {
                index: true,
                element: <LiveList />,
              },
              {
                path: ':liveId',
                element: <LiveDetails />,
              },
            ],
          },
          {
            path: '/comments',
            children: [
              {
                index: true,
                element: <CommentsList />,
              },
            ],
          },
          {
            path: '/customer',
            children: [
              {
                index: true,
                element: <CustomerList />,
              },
              { path: ':customerId', element: <CustomerDetails /> },
            ],
          },
          {
            path: '/order',
            children: [
              {
                index: true,
                element: <OrderList />,
              },
              {
                path: ':orderId',
                element: <OrderDetails />,
              },
            ],
          },
          {
            path: '/shipping',
            children: [{ index: true, element: <ShippingPage /> }],
          },
          {
            path: '/product',
            children: [
              {
                index: true,
                element: <ProductList />,
              },
            ],
          },
          {
            path: '/payment',
            children: [
              {
                index: true,
                element: <PaymentList />,
              },
            ],
          },
          {
            path: '/refund',
            children: [{ index: true, element: <RefundList /> }],
          },
          {
            path: '/settings',
            children: [
              {
                index: true,
                element: <Settings />,
              },
            ],
          },
          {
            path: '/invoice',
            children: [
              {
                index: true,
                element: <InvoicePage />,
              },
            ],
          },
          {
            path: '/parcel',
            children: [
              {
                index: true,
                element: <ParcelListPage />,
              },
            ],
          },
          {
            path: '/personal',
            children: [
              {
                index: true,
                element: <PersonalPage />,
              },
            ],
          },
          {
            path: '/broadcast',
            children: [
              {
                index: true,
                element: <BroadcastPage />,
              },
            ],
          },
        ],
      },
    ],
  },
]);
